/* tjs <- configure-tjs-debug.ts */

import { version } from './version'

import { configureTjs } from './configure-tjs'

configureTjs({ throwTypeErrors: true, logTypeErrors: true });

console.info(`tosijs/debug ${version} — EXPERIMENTAL tjs-built bundle. Ships runtime ` +
    'type metadata (__tjs) per function; runtime type enforcement arrives ' +
    'as modules move to native TJS (tosijs 2.0). Not for production.');